(function () {
  function activar(cont, indice) {
    var tabs = cont.querySelectorAll('[data-pestana-tab]');
    var paneles = cont.querySelectorAll('[data-pestana-panel]');

    var actBg = getComputedStyle(cont).getPropertyValue('--pest-tab-act-bg').trim();
    var actTx = getComputedStyle(cont).getPropertyValue('--pest-tab-act-tx').trim();
    var inactBg = getComputedStyle(cont).getPropertyValue('--pest-tab-inact-bg').trim();
    var inactTx = getComputedStyle(cont).getPropertyValue('--pest-tab-inact-tx').trim();

    for (var i = 0; i < tabs.length; i++) {
      var activa = (i === indice);
      tabs[i].setAttribute('aria-selected', activa ? 'true' : 'false');
      tabs[i].style.backgroundColor = activa ? actBg : inactBg;
      tabs[i].style.color = activa ? actTx : inactTx;
    }
    for (var j = 0; j < paneles.length; j++) {
      paneles[j].style.display = (j === indice) ? 'block' : 'none';
    }
  }

  function initCont(cont) {
    if (cont.getAttribute('data-pestanas-init') === '1') return;
    cont.setAttribute('data-pestanas-init', '1');

    var tabs = cont.querySelectorAll('[data-pestana-tab]');
    for (var i = 0; i < tabs.length; i++) {
      (function (indice) {
        tabs[indice].addEventListener('click', function () {
          activar(cont, indice);
        });
      })(i);
    }
  }

  function init() {
    var conts = document.querySelectorAll('[data-pestanas]');
    for (var i = 0; i < conts.length; i++) {
      initCont(conts[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
